import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { PageContentHeader, Typography } from 'seagull';
import styles from './MinisiteTabHeader.module.scss';
export default function MinisiteTabHeader(_0) {
    let { text, actions, appcuesId, testId, inline = false, className } = _0, props = _object_without_properties(_0, [
        "text",
        "actions",
        "appcuesId",
        "testId",
        "inline",
        "className"
    ]);
    const body = /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, props), {
        className: cn(styles.root, className),
        "data-appcuesid": appcuesId,
        "data-testid": testId,
        children: [
            text && /*#__PURE__*/ _jsx(Typography, {
                variant: "h6",
                className: styles.header,
                children: text
            }),
            actions && /*#__PURE__*/ _jsx("div", {
                className: styles.actions,
                children: actions
            })
        ]
    }));
    return inline ? body : /*#__PURE__*/ _jsx(PageContentHeader, {
        children: body
    });
}
